import yup from '../../../config/yup';

export const xmlReadValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('xml'),
  properties: yup.object().shape({
    inferSchema: yup.boolean(),
    mode: yup.string(),
    columnNameOfCorruptRecord: yup.string(),
    rowTag: yup.string(),
  }),
});

export const xmlReadFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'XML ID',
    },
    '@data-type': {
      type: 'string',
      title: 'Data Type',
      default: 'format',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'xml',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        inferSchema: {
          type: 'boolean',
          title: 'Infer Schema',
        },
        mode: {
          type: 'string',
          title: 'Mode',
        },
        columnNameOfCorruptRecord: {
          type: 'string',
          title: 'Column Name Of Corrupt Record',
        },
        rowTag: {
          type: 'string',
          title: 'Row Tag',
        },
      },
    },
  },
  required: ['@id', '@data-type', 'name', 'type'],
};

export const xmlReadFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated after saving',
  },
  '@data-type': {
    'ui:readonly': true,
  },
  type: {
    'ui:readonly': true,
  },
  inferSchema: {
    'ui:widget': 'checkbox',
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};

export const xmlWriteValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('xml'),
  properties: yup.object().shape({
    rootTag: yup.string(),
    rowTag: yup.string(),
  }),
});

export const xmlWriteFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Format ID',
    },
    '@data-type': {
      type: 'string',
      title: 'Data Type',
      default: 'format',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'xml',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        rootTag: {
          type: 'string',
          title: 'Root Tag',
        },
        rowTag: {
          type: 'string',
          title: 'Row Tag',
        },
      },
    },
  },
  required: ['@id', '@data-type', 'name', 'type'],
};

export const xmlWriteFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated',
  },
  '@data-type': {
    'ui:readonly': true,
  },
  type: {
    'ui:readonly': true,
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};
